import { useGateValue } from '@statsig/react-bindings';

export default function useIsForOrganizationsEnabled() {
  return useGateValue('for_organizations_enabled');
}
